export default {
  default: () => import("/app/layouts/default.vue"),
  "footer-less": () => import("/app/layouts/footerLess.vue"),
  news: () => import("/app/layouts/news.vue"),
  training: () => import("/app/layouts/training.vue")
}